import React from "react";

const CrossIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 21"
      className={className ? className : "w-[20px] h-[21px]"}
      {...rest}
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        // strokeWidth="1.5"
        clipPath="url(#clip0_5274_44202)"
      >
        <path d="m15.625 4.875-11.25 11.25M15.625 16.125 4.375 4.875"></path>
      </g>
      <defs>
        <clipPath id="clip0_5274_44202">
          <path fill="currentColor" d="M0 .5h20v20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossIcon;
